import Skeleton from "@mui/joy/Skeleton";
import React, { forwardRef } from "react";

interface ImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
  // Add any custom props you need here, e.g.,
  // onLoad: () => void;
  // onError: () => void;
}

const Image = forwardRef<HTMLImageElement, ImageProps>(
  ({ src, alt, onError, ...rest }, ref) => {
    const [loading, setLoading] = React.useState(true);

    return (
      <Skeleton
        loading={loading}
        height={loading ? 120 : "auto"}
        variant="rectangular"
      >
        <img
          className={`max-h-64`}
          src={src}
          alt={alt}
          ref={ref}
          onLoad={() => {
            setLoading(false);
          }}
          onError={onError}
          {...rest}
        />
      </Skeleton>
    );
  }
);

export default Image;
